(function (factory) {
    typeof define === 'function' && define.amd ? define(factory) :
    factory();
}((function () { 'use strict';

    document.addEventListener('DOMContentLoaded', function () {

        // Get filter "All"
        var filterAll = document.querySelector('.elementor-widget-taxonomy-filter .e-filter-item-gw[data-filter="__all_gw"]');

        if (filterAll) {
            filterAll.addEventListener('click', function(e) {
                e.preventDefault();
                var allHref = window.location.href.split("?")[0];
                if(window.location.href !== allHref) {
                    window.location = allHref;
                }
            }, false);
        }
    });

})));
//# sourceMappingURL=gw-elementor-addons.min.js.map
